import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Wrapper,
  Information,
  Logos,
  Sections,
  Head,
  Foot,
  AssesorsWrapper,
  Content,
  Shadow,
  Bold,
  WrapperIcons,
  SecurityWrapper,
  Price,
  Title,
  TopSection,
  BottomSection
} from './styled';
import * as LogoGEC from '@app/src/assets/img/logo-gec.svg';
import * as LogoTrome from '@app/src/assets/img/logo-trome.svg';
import { COLORS } from '@app/src/ui';
import { Icon } from '@app/src/common/Icon';
import { Logo } from '@app/src/common/header';
import { isClientEnv } from '@app/src/utils/validations';
import { CategoriesShimmer, fetchCategories } from '@app/src/views/Home/listProducts';
import { CATEGORIES } from '@app/src/config/categories';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  setPosition?: Function;
}

export const CoverPage: React.FC<Props> = ({
  setPosition
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const categories = useSelector(state => state.categories.data);
  const isFetching: boolean = useSelector(state => state.categories.isFetching);
  const error: boolean = useSelector(state => state.categories.error);
  const [navigation, setNavigation] = useState([]);

  useEffect(() =>{
    if (isClient) {
      (window as any).sessionStorage.removeItem('print');
    }
  }, []);

  useEffect(() => {
    if (categories && categories.length === 0) {
      dispatch(fetchCategories());
    }
    if (categories && categories.length > 0) {
      let newCategories = categories.filter((item) => item.order !== CATEGORIES.vehiculo.order);
      setNavigation([
        ...newCategories,
        categories[CATEGORIES.vehiculo.order - 1]
      ])
    }
  }, [categories]);

  const [ isChangeOrientation, setIsChangeOrientation ] = useState(false);

  useEffect(() => {
    if (isClient) {
      handleResize();
      window.addEventListener('resize', handleResize);
      return() => window.removeEventListener('resize', handleResize);
    }
  });

  const handleResize = () => {
    const mobileSizeOrientation: number = 768;
    const isLessThanMobileSizeOrientation: boolean = window.innerHeight < mobileSizeOrientation;
    isLessThanMobileSizeOrientation
      ? setIsChangeOrientation(true)
      : setIsChangeOrientation(false);
  };

  const handleClick = (e, item) => {
    if (isClient) {
      e.preventDefault();
      const { active, link, text } = item;
      let element = e.currentTarget;
      let id = element.hash.replace('#','');
      const path = `${link}-1`;

      if (window.innerWidth >= BREAKPOINT) {
        if (active) {
          history.push(path);
        } else {
          setPosition && setPosition(e,id);
        }
      } else {
        if (active) {
          history.push(path);
        } else {
          let section = document.querySelector(`[data-scroll=${id}]`);
          window.scroll({top: section['offsetTop'], behavior:'smooth' });
        }
      }

      pushDatalayer(text, path);
    }
  };

  const pushDatalayer = (categoryName: string, pathPage: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'BotonesCategorías',
        'eventAction': categoryName,
        'eventLabel': pathPage,
        'eventValue': 1
      })
    }
  };

  return (
    <React.Fragment>
        <Wrapper id="inicio" data-scroll="inicio">
          <Shadow />
          <Content isChangeOrientation={isChangeOrientation}>
            <Head>
              <Logo />
            </Head>
            <TopSection>
              <Information>Publica tu <Bold>AVISO IMPRESO</Bold> en los diarios más vistos del Perú</Information>
              <Logos>
                <img src={LogoGEC} alt="el comercio" />
                <img src={LogoTrome} alt="trome" />
              </Logos>
            </TopSection>
            <BottomSection>
              <Sections>
                {
                  isFetching || error
                  ? <CategoriesShimmer />
                  : navigation.map((item, index) =>
                      <WrapperIcons
                        key={index}
                        color={item.color}>
                        <a
                          href={`#${item.alias}`}
                          onClick={e => handleClick(e,item)}>
                          <Icon data-name={item.icon} width="25" height="25" fill={COLORS.BLACK} />
                          <Title>{item.text}</Title>
                          <Price>Desde {item.price}</Price>
                        </a>
                      </WrapperIcons>
                  )
                }
              </Sections>
              <Foot>
                  <SecurityWrapper />
                  <AssesorsWrapper />
              </Foot>
            </BottomSection>
          </Content>
        </Wrapper>
    </React.Fragment>
  );
};

CoverPage.displayName = 'CoverPage';
